import React from 'react';
import { connect } from 'react-redux';
import Icon from '../Icon';

const Message = (props) => {
  const {
    message, type, style, customStyle, disableIcon
  } = props;

  return (
    <p style={customStyle || style}>
      {type !== 'success' && !disableIcon && <Icon style={{ fontSize: '20px' }} iconName='warning' />}
      {message}
    </p>
  );
};

const buildStyle = (style) => {
  if (!style || !style.body) return {};
  return {
    color: style.body.backgroundColor,
    fontFamily: style.body.fontFamily,
    fontSize: style.body.fontSize,
  };
};

export default connect(
  ({ settings }) => ({
    style: buildStyle(settings.style),
  }),
)(Message);
